import { Divider, Stack } from "@mantine/core"
import { AnswerComment } from "./AnswerComment"
import type { IMultiAnswerProps } from "./types"
import { filterAnswersWithComment } from "./utils"

export function MultiAnswerString({ question, answers: answersDone }: IMultiAnswerProps) {
  answersDone = filterAnswersWithComment(answersDone)
  return (
    <Stack gap={0}>
      {answersDone.map((a, idx) => (
        <AnswerComment question={question} answer={a} key={a.id} p="xs" pl="sm">
          {idx > 0 && <Divider variant="solid" />}
        </AnswerComment>
      ))}
    </Stack>
  )
}
